
@if (isAdmin()) {
  <span><button mat-stroked-button (click)="onAddClick()">Add<mat-icon>add</mat-icon></button><button mat-stroked-button (click)="onClickRefresh()">Refresh</button></span>
}
@if (showForm) {
  <span><button mat-stroked-button (click)="onCloseClick()">Close<mat-icon>close</mat-icon></button>
    @let resource = selectedResource$ | async;
    @if (resource) {
    <resource-form [resource]="resource" (notifyParent)="ResourceSubmittedHandler($event)"></resource-form>
    }
  </span>
}

<h2>Resources</h2>
<calendly-bookings [person]="person"></calendly-bookings>

@if (resourceCategories) {
  <div >
    <form [formGroup]="SearchForm" (ngSubmit)="submitSearchForm()" class="Pearl-form" novalidate >
      <mat-form-field appearance="outline" >
        <mat-label>Search</mat-label>
        <input matInput  formControlName="content" placeholder="Search text"/>
      </mat-form-field>
      &nbsp; &nbsp;
      <mat-form-field appearance="outline" >
        <mat-label>Natural Number?</mat-label>
        <mat-select matNativeControl formControlName="naturalNumbers" multiple>
          @for (nnI of nnKeys; track nnI) {
            <mat-option [value]="nnI">{{ nnI }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      &nbsp; &nbsp;
      @if (isAdmin()) {
        <mat-form-field appearance="outline" >
          <mat-label>Levels</mat-label>
          <mat-select matNativeControl formControlName="eventCategories" multiple>
            @for (reltype of programs; track reltype) {
              <mat-option [value]="reltype">{{ reltype }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      &nbsp; &nbsp;
      <mat-form-field appearance="outline">
        <mat-label>Resource Types</mat-label>
        <mat-select matNativeControl formControlName="resourceTypes" multiple>
          @for (reltype of resourceTypes ; track reltype) {
            <mat-option [value]="reltype">{{ reltype}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      &nbsp; &nbsp;
      &nbsp; &nbsp;
      <mat-form-field appearance="outline">
        <mat-label>Categories</mat-label>
        <mat-select matNativeControl formControlName="resourceCategories" multiple>
          @for (reltype of resourceCategories ; track reltype) {
            <mat-option [value]="reltype">{{ reltype}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button mat-button type="submit" [disabled]="disableBtn" class="btn btn-save mat-submit-button">Search</button>
    </form>
  </div>
}
<table mat-table [dataSource]="dataSource" matSort>

  <ng-container matColumnDef="edit">
    <th mat-header-cell *matHeaderCellDef> Edit </th>
    <td mat-cell *matCellDef="let element" class="td-center-text">
      <button type="button" (click)="onClickEdit(element)"> <mat-icon>edit</mat-icon></button>
    </td>
  </ng-container>

  <ng-container matColumnDef="dateCreated">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Created </th>
    <td mat-cell *matCellDef="let element" > {{ dateFormating(element.meta.dateCreated, "purchased") }} </td>
  </ng-container>

  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef mat-sort-header style='width:40%;'> Title / Content </th>
    <td mat-cell *matCellDef="let element"> {{element.title}} <div class="description"><div [innerHTML]="element.description"></div> </div></td>
  </ng-container>

  <ng-container matColumnDef="aboutNN" style="max-width:5%">
    <th mat-header-cell *matHeaderCellDef mat-sort-header nowrap> Nat-Nums </th>
    <td mat-cell *matCellDef="let element" class="td-center-text">
      {{element.aboutNN}}
    </td>
  </ng-container>

  <ng-container matColumnDef="eventCategories">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Levels </th>
    <td mat-cell *matCellDef="let element" class="td-center-text">
      {{ element.eventCategories.join(", ") }}
    </td>
  </ng-container>
  <ng-container matColumnDef="resourceCategories">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Categories </th>
    <td mat-cell *matCellDef="let element" class="td-center-text">
      {{ element.resourceCategories.join(", ") }}
    </td>
  </ng-container>

  <ng-container matColumnDef="resourceType">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
    <td mat-cell *matCellDef="let element" class="td-center-text" style='text-align:center;'>
      {{ element.resourceType}}<br>
      <small>
        @if (element.url) {
          <span><a href="{{ element.url}}" target="_blank"><mat-icon >visibility</mat-icon>VIEW</a></span>
        }
        @if (element.url && element.fileInfo && element.fileInfo.length > 0) {
          <span><hr class='divider' /></span>
        }
        @if (element.fileInfo && element.fileInfo.length > 0) {
          <span>
            <a href="{{element.fileInfo[0].Location}}" target="_blank">DWNLD</a>
          </span>
        }
      </small>
    </td>
  </ng-container>

  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef> Delete </th>
    <td mat-cell *matCellDef="let element" class="td-center-text">
      <button type="button" (click)="onClickDelete(element)"> <mat-icon>delete</mat-icon></button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>

</table>
<mat-paginator   [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 15, 20, 50, 100]"></mat-paginator>
